export default "__VITE_PUBLIC_ASSET__ce4bcf59__"